import { getField, updateField } from "vuex-map-fields";
import { getNewId } from "@/utils/id";
import BaseBoundaryCondition from "./baseBoundaryCondition";
import api from "../api/api";

export const namespaced = true;

let baseUrl = "/settlement/";
let paginationUrl = "/reference_point_settlement/";
let yearSet = {};

const baseBoundaryCondition = new BaseBoundaryCondition(
  baseUrl,
  paginationUrl
);

const getDefaultState = () => {
  return {
    ...structuredClone(baseBoundaryCondition.state),
    importedYears: [],
    templateFileName: "Settlement.xlsx",
  };
};
export const state = getDefaultState();

export const mutations = {
  ...baseBoundaryCondition.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  RESET_IMPORT_STATE(state) {
    state.importItems = [];
    state.uploadLoading = false;
    state.importLoading = false;
    state.ignoredReferencePoint = [];
    state.importedYears = [];
  },
  updateField,
};
export const actions = {
  ...baseBoundaryCondition.actions,
  getNewSettlement(context, referencePointId) {
    let settlement = [];
    let ids = [];
    let years = context.rootState.project.currentProject.year_set;
    if (context.state.years.length) {
      years = context.state.years;
    }
    years.forEach((year) => {
      let id = getNewId(context.getters.getItems, "id", ids);
      settlement.push(
        context.getters.getEmptySettlement(id, referencePointId, year.id)
      );
      ids.push(id);
    });
    return settlement;
  },
  async addNewItem(context) {
    let referencePointId = getNewId(
      context.getters.getItems,
      "reference_point"
    );
    let settlement = await context.dispatch(
      "getNewSettlement",
      referencePointId
    );
    let newItem = {
      id: referencePointId,
      reference_point: referencePointId,
      settlement_set: settlement,
    };
    context.commit("ADD_ITEM", newItem);
    context.commit("ADD_COUNT", 1);
  },
  async uploadFile(context, formData) {
    formData.append(
      "project_id",
      context.rootGetters["project/selectedProjectId"]
    );
    context.commit("TOGGLE_UPLOAD_LOADING");
    try {
      let response = await api.post(paginationUrl + "bulk_upload/", formData);
      let responseData = response["data"]["results"];
      let dataImport = [];
      context.commit("SET_IMPORTED_YEARS", response["data"]["file_year"]);
      context.rootState.project.currentProject.year_set.forEach((year) => {
        yearSet[year.id] = year.year;
      });
      if (responseData.length) {
        for (let idx = 0; idx < responseData.length; idx++) {
          let settlement = responseData[idx]["settlement_set"];
          dataImport.push(sortData(responseData[idx], settlement));
        }
      }
      context.commit("ADD_IMPORT_ITEMS", dataImport);
      context.commit(
        "ADD_IGNORE_REFERENCE_POINT",
        response.data["ignored_reference_point"]
      );
      context.commit("TOGGLE_UPLOAD_LOADING");
    } catch (e) {
      console.log(e);
      context.commit("TOGGLE_UPLOAD_LOADING");
    }
  },
  
};

export const getters = {
  getField,
  getEmptySettlement: (state) => (id, referencePointId, yearId) => {
    let emptyObj = {};
    Object.keys(state.options).forEach((key) => (emptyObj[key] = ""));
    emptyObj.id = id;
    emptyObj.year = yearId;
    emptyObj.reference_point = referencePointId;
    return emptyObj;
  },
  getExportFileName: (state, getters, rootState) => {
    let projectName = rootState["project"].currentProject?.name
    return projectName + "_Settlement_export.xlsx";
  },
  getItems: (state) => {
    let settlement = [];
    state.items.forEach((referencePoint) =>
      settlement.push(...referencePoint.settlement_set)
    );
    return settlement;
  },
};

function sortData(general, settlement) {
  let sortedSettlement = settlement.sort(function (a, b) {
    if (yearSet[a.year.toString()] < yearSet[b.year.toString()]) return -1;
    if (yearSet[a.year.toString()] > yearSet[b.year.toString()]) return 1;
    return 0;
  });
  return {
    ...general,
    settlement_set: sortedSettlement,
  };
}
